import { useCallback } from 'react';

const useDownload = () => {
  const base64toBlob = useCallback((base64Data) => {
    const sliceSize = 1024;
    const byteCharacters = Buffer.from(base64Data, 'base64').toString('latin1');
    const bytesLength = byteCharacters.length;
    const slicesCount = Math.ceil(bytesLength / sliceSize);
    const byteArrays = new Array(slicesCount);

    for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      const begin = sliceIndex * sliceSize;
      const end = Math.min(begin + sliceSize, bytesLength);

      const bytes = new Array(end - begin);
      for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: 'application/pdf' });
  }, []);

  const generateUrlPdf = (base64pdf) => {
    const blob = base64toBlob(base64pdf);
    return URL.createObjectURL(blob);
  };

  return {
    base64toBlob,
    generateUrlPdf,
  };
};

export default useDownload;
